import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { processGoogleAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login");
      return;
    }

    const process = async () => {
      try {
        const user = await processGoogleAuth(sessionId);
        navigate(user.onboarding_completed ? "/dashboard" : "/onboarding", { replace: true });
      } catch {
        navigate("/login");
      }
    };
    process();
  }, [navigate, processGoogleAuth]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background" data-testid="auth-callback">
      <Loader2 className="w-10 h-10 animate-spin text-primary mb-4" />
      <p className="font-body text-muted-foreground">Anmeldung wird verarbeitet...</p>
    </div>
  );
}
